import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="intersectionobserver" id="intersectionobserver"></a>
    <h1 {...{
      "id": "windowintersectionobserver"
    }}>{`window.IntersectionObserver`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver"
      }}>{`IntersectionObserver`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="new-intersectionobserver-new" id="new-intersectionobserver-new"></a>
    <h2 {...{
      "id": "intersectionobservercallback-options"
    }}>{`IntersectionObserver(callback, `}{`[options]`}{`)`}</h2>
    <p>{`Provides a mechanism to asynchronously observe changes in the intersection of a target element with an ancestor element or with a top-level document element.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`SyntaxError`}</inlineCode>{` If the `}<inlineCode parentName="li">{`rootMargin`}</inlineCode>{` or `}<inlineCode parentName="li">{`scrollMargin`}</inlineCode>{` values are invalid.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`RangeError`}</inlineCode>{` If any `}<inlineCode parentName="li">{`threshold`}</inlineCode>{` values are outside the range of 0.0 to 1.0.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`callback`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The function called whenever an intersection event is triggered.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Options to configure the observation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.root]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Element`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`\`\``}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The element that is used as the viewport for checking visibility of the target. If not specified, the document's viewport is used.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.rootMargin]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;0px\\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Margin around the root. Can have values similar to the CSS margin property.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.scrollMargin]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;0px\\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Margin applied to the scroll container during intersection calculation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.threshold]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Array<number>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A single number or an array of numbers indicating at what percentage of the target's visibility the observer's callback should be executed.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="intersectionobserver-root" id="intersectionobserver-root"></a>
    <h2 {...{
      "id": "root--element"
    }}>{`root : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p>{`Gets the root element being used for intersection calculation.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/root"
      }}>{`IntersectionObserver - root`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserver-rootmargin" id="intersectionobserver-rootmargin"></a>
    <h2 {...{
      "id": "rootmargin--string"
    }}>{`rootMargin : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Gets the root margin applied to the intersection calculation.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/rootMargin"
      }}>{`IntersectionObserver - rootMargin`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserver-thresholds" id="intersectionobserver-thresholds"></a>
    <h2 {...{
      "id": "thresholds--arraynumber"
    }}>{`thresholds : `}<inlineCode parentName="h2">{`Array<number>`}</inlineCode></h2>
    <p>{`Gets the list of thresholds used for triggering the observer's callback.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/threshold"
      }}>{`IntersectionObserver - threshold`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserver-scrollmargin" id="intersectionobserver-scrollmargin"></a>
    <h2 {...{
      "id": "scrollmargin--string"
    }}>{`scrollMargin : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Gets the scroll margin applied to the scroll container during intersection calculation.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://w3c.github.io/IntersectionObserver/#dom-intersectionobserver-scrollmargin"
      }}>{`IntersectionObserver - scrollMargin`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserver-observe" id="intersectionobserver-observe"></a>
    <h2 {...{
      "id": "observetarget"
    }}>{`observe(target)`}</h2>
    <p>{`Starts observing the specified target element for intersection changes.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` If the target is not an instance of `}<inlineCode parentName="li">{`Element`}</inlineCode>{`.`}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/observe"
      }}>{`IntersectionObserver - observe`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`target`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Element`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The element to be observed.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="intersectionobserver-unobserve" id="intersectionobserver-unobserve"></a>
    <h2 {...{
      "id": "unobservetarget"
    }}>{`unobserve(target)`}</h2>
    <p>{`Stops observing the specified target element.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` If the target is not an instance of `}<inlineCode parentName="li">{`Element`}</inlineCode>{`.`}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/unobserve"
      }}>{`IntersectionObserver - unobserve`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`target`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Element`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The element to stop observing.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="intersectionobserver-disconnect" id="intersectionobserver-disconnect"></a>
    <h2 {...{
      "id": "disconnect"
    }}>{`disconnect()`}</h2>
    <p>{`Disconnects the IntersectionObserver instance from all observed target elements.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/disconnect"
      }}>{`IntersectionObserver - disconnect`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="intersectionobserver-takerecords" id="intersectionobserver-takerecords"></a>
    <h2 {...{
      "id": "takerecords"
    }}>{`takeRecords()`}</h2>
    <p>{`Returns a list of IntersectionObserverEntry objects for all observed elements.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Array<IntersectionObserverEntry>`}</inlineCode>{` - An array of IntersectionObserverEntry objects.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/takeRecords"
      }}>{`IntersectionObserver - takeRecords`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      